import React, {useEffect, useState} from "react";
import useExpanderTable from '../expander-table/hooks';
import CircularProgress from "@material-ui/core/CircularProgress";
import PropTypes from "prop-types";

const ExpanderTableContent = ({noData = 'Nothing to show', children}) => {
    const [state, ] = useExpanderTable();
    const [showLoader, setShowLoader] = useState(false);

    // Delay showing the table loader if we're getting responses in under 250ms
    useEffect(() => {

        if (state.isFetching) {
            const timer = setTimeout(() => setShowLoader(true), 200)
            return () => {clearTimeout(timer)}
        } else {
            setShowLoader( false)
        }
    }, [state.isFetching])


    if (!state) {
        console.warn("ExpanderTableContent must be a descendant of ExpanderTable")
        return null;
    }

    return (
        <div style={{position:'relative', minHeight: 48}}>
            { state.rows.length === 0 ?
                <div className="p-4 border-b h-12 bg-white">{ state.isFetching ? '' : noData}</div>
                : null
            }

            {children}

            { showLoader ?
                <div className="absolute inset-0 bg-white bg-opacity-75" >
                    <div className="flex flex-col h-full">
                        <div className="m-auto">
                            <CircularProgress color="secondary"/>
                        </div>
                    </div>
                </div>
                : null
            }

        </div>
    )
}

ExpanderTableContent.propTypes = {
    noData : PropTypes.string
}

export default ExpanderTableContent;